import { Theme } from '@chakra-ui/react'
import { DeepPartial } from '../../../common/types'

interface NucbaProgress extends DeepPartial<Theme['components']['Progress']> {}

export const Progress: NucbaProgress = {
  baseStyle: {
    filledTrack: {
      backgroundColor: 'nucba.primary',
    },
    track: {
      borderRadius: '46px',
      backgroundColor: 'rgba(255, 0, 92, 0.25);',
    },
  },
}
